import React, { useState } from 'react';
import { userService, uploadService } from '../api/services';
import AdminModal from './AdminModal';

const formatDateInputValue = (value) => (value ? String(value).split('T')[0] : '');

// 名錄編輯 pop up：具 directory.manage 權限者可編輯夥伴的名錄欄位。
// 僅限名錄欄位（姓名/暱稱/聯絡方式/LINE/入職日/頭像），不含角色/狀態/密碼/帳號等敏感欄位（那些仍由 ADMIN 後台管理）。
const DirectoryEditModal = ({ person, onClose, onSaved }) => {
  const [form, setForm] = useState({
    name: person?.name || '',
    nickname: person?.nickname || '',
    contact_info: person?.contact_info || '',
    line_id: person?.line_id || '',
    joined_at: formatDateInputValue(person?.joined_at),
    avatar_url: person?.avatar_url || '',
  });
  const [busy, setBusy] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleUpload = async (file) => {
    if (!file) return;
    if (!file.type.startsWith('image/')) { setError('請選擇圖片檔案'); return; }
    setUploading(true);
    setError('');
    try {
      const fd = new FormData();
      fd.append('purpose', 'directory-avatar');
      fd.append('files', file, file.name);
      const res = await uploadService.upload(fd);
      const url = res.data?.[0]?.url;
      if (url) setForm((p) => ({ ...p, avatar_url: url }));
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setUploading(false);
    }
  };

  const handleSave = async () => {
    if (!form.name.trim()) { setError('請填寫真實姓名'); return; }
    setBusy(true);
    setError('');
    try {
      await userService.updateDirectory(person.id, { ...form, joined_at: form.joined_at || null });
      onSaved?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
      setBusy(false);
    }
  };

  return (
    <AdminModal title={`編輯名錄：${person?.nickname || person?.name}`} onClose={onClose}>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="admin-form-row" style={{ flexDirection: 'column', alignItems: 'stretch', gap: 12 }}>
        <label>真實姓名 *</label>
        <input className="form-control form-control-sm" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} placeholder="真實姓名" />
        <label>暱稱</label>
        <input className="form-control form-control-sm" value={form.nickname} onChange={(e) => setForm((p) => ({ ...p, nickname: e.target.value }))} placeholder="顯示暱稱" />
        <label>聯絡方式</label>
        <input className="form-control form-control-sm" value={form.contact_info} onChange={(e) => setForm((p) => ({ ...p, contact_info: e.target.value }))} placeholder="電話 / Slack / ..." />
        <label>LINE ID</label>
        <input className="form-control form-control-sm" value={form.line_id} onChange={(e) => setForm((p) => ({ ...p, line_id: e.target.value }))} placeholder="LINE ID" />
        <label>入職日</label>
        <input className="form-control form-control-sm" type="date" value={form.joined_at} onChange={(e) => setForm((p) => ({ ...p, joined_at: e.target.value }))} />
        <label>頭像 URL</label>
        <input className="form-control form-control-sm" value={form.avatar_url} onChange={(e) => setForm((p) => ({ ...p, avatar_url: e.target.value }))} placeholder="https://... 或於下方上傳" />
        <label>上傳頭像</label>
        <input className="form-control form-control-sm" type="file" accept="image/*" disabled={uploading} onChange={(e) => handleUpload(e.target.files?.[0])} />
        {uploading && <div className="setting-desc">圖片上傳中...</div>}
        {form.avatar_url && <img src={form.avatar_url} alt="預覽" style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: '50%', border: '1px solid var(--border-color)' }} />}
        <div className="btn-group" style={{ justifyContent: 'flex-end', marginTop: 8 }}>
          <button className="btn btn-sm btn-primary" disabled={busy || uploading} onClick={handleSave}>{busy ? '儲存中...' : '儲存'}</button>
          <button className="btn btn-sm btn-secondary" disabled={busy} onClick={onClose}>取消</button>
        </div>
      </div>
    </AdminModal>
  );
};

export default DirectoryEditModal;
